export default class ConfigService {
    static get() {
      if (!global.configuration) {
          debugger;
          throw new Error("Config has not be set. Please set global.config before calling get.");
      }
      return global.configuration;
    }
  }